import React, { Component } from 'react';
import Routes from '../Router'
/*import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'*/
import './bootstrap.css'
import './mainstyles.css'
import './navbar.css'
import './otw-blog-manager.css'
import './otw-grid.css'
import './fontello.css'
import './font-awesome.min.css'
import './krypton.css'
import './plugin.css'
import './custom.css'

class FullPage extends Component {
  	render() {
	    return (
	      <div>
	          <Routes/>
	      </div>
	    );
  	}
}

export default FullPage;



// WEBPACK FOOTER //
// ./src/components/FullPage/index.js